import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      sessionStorage.setItem("admin_token", res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#03170D] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="glass-card rounded-2xl p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="w-12 h-12 rounded-full bg-[rgba(212,175,55,0.15)] flex items-center justify-center">
              <Lock className="h-6 w-6 text-[#D4AF37]" />
            </div>
          </div>
          <h1
            data-testid="admin-login-title"
            className="text-2xl font-medium text-white text-center mb-2"
          >
            Admin Access
          </h1>
          <p
            className="text-sm text-[#647D6C] text-center mb-8"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Sign in to access the analytics dashboard
          </p>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="text-sm text-[#A3B8AA] block mb-1.5" style={{ fontFamily: "Outfit, sans-serif" }}>
                Username
              </label>
              <input
                data-testid="admin-username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="w-full px-4 py-3 rounded-xl border border-[#1A4026] bg-[rgba(10,39,22,0.4)] text-white placeholder-[#647D6C] outline-none focus:border-[#D4AF37] transition-colors"
                style={{ fontFamily: "Outfit, sans-serif" }}
                autoFocus
              />
            </div>
            <div>
              <label className="text-sm text-[#A3B8AA] block mb-1.5" style={{ fontFamily: "Outfit, sans-serif" }}>
                Password
              </label>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full px-4 py-3 rounded-xl border border-[#1A4026] bg-[rgba(10,39,22,0.4)] text-white placeholder-[#647D6C] outline-none focus:border-[#D4AF37] transition-colors"
                style={{ fontFamily: "Outfit, sans-serif" }}
              />
            </div>

            {error && (
              <p data-testid="admin-login-error" className="text-red-400 text-sm text-center" style={{ fontFamily: "Outfit, sans-serif" }}>
                {error}
              </p>
            )}

            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={!username || !password || loading}
              className="w-full bg-[#D4AF37] hover:bg-[#F0CC5C] text-[#03170D] font-semibold py-5 rounded-full disabled:opacity-40"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
